import cn from 'classnames';

import Icon from '@/components/Icon';
import Link from '@/components/renderers/Link';
import Paragraph from '@/components/renderers/Paragraph';
import Pill from '@/components/Pill';

export default function IconContentBlock(
  { icon, title, description, comingSoon = false, cta, ctaTo, ctaClass },
  index,
) {
  return (
    <div key={index} className="w-full md:w-1/2 lg:w-1/3 p-6 flex">
      <div className="bg-whisper rounded-lg p-6 w-full flex flex-col justify-between">
        <div>
          {icon && (
            <div className="h-12 w-12 flex items-center justify-center mb-6 text-cornflower">
              <Icon icon={icon} />
            </div>
          )}

          <div className="flex items-baseline">
            <h4 className="text-haiti font-bold">{title}</h4>
            {comingSoon && <Pill label="Soon" size="small" className="ml-4" />}
          </div>

          {description && (
            <Paragraph className="text-mid-gray">{description}</Paragraph>
          )}
        </div>

        {ctaTo && (
          <Link href={ctaTo} className={cn('cursor-pointer', ctaClass)}>
            {cta || 'Learn more'} &#8594;
          </Link>
        )}
      </div>
    </div>
  );
}
